export default __webpack_public_path__ + "static/media/question.dcca6a8a.png";